import { useMemo } from 'react';

import {
  ChevronDownIcon,
  Center,
  type ButtonProps,
} from '@frontend/components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export interface DropdownIndicatorProps<OptionType extends CascaderOption>
  extends ButtonProps {
  getCommonProps: () => CascaderCommonProps<OptionType>;
}

export const InternalDropdownIndicator = <
  OptionType extends CascaderOption,
>() => {
  const { comboboxApi, cascaderStyles, getCommonProps } =
    useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomDropdownIndicator = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.DROPDOWN_INDICATOR),
    [getComponent],
  );

  return (
    <CustomDropdownIndicator
      getCommonProps={getCommonProps}
      __css={cascaderStyles.dropdownIndicator}
      {...comboboxApi.getTriggerProps()}
      className="cascader-dropdown-indicator"
    />
  );
};

export const DropdownIndicator = <OptionType extends CascaderOption>({
  getCommonProps: _,
  ...rest
}: DropdownIndicatorProps<OptionType>) => {
  return (
    <Center as="button" {...rest} tabIndex={-1}>
      <ChevronDownIcon boxSize="calc(100% * 2 / 3)" />
    </Center>
  );
};
